import { PUBLIC_RESPONSE_SCHEMA_VERSION } from '../../services/public/publicMailingResponseRequest.js';

export const EMPTY_PUBLIC_PROSPECT_FORM = Object.freeze({
  schemaVersion: PUBLIC_RESPONSE_SCHEMA_VERSION,
  intent: '',
  contact: { fullName: '', email: '', phone: '' },
  consentAccepted: false,
  ownershipAttested: false,
  language: 'fr',
});

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phonePattern = /^\+?[0-9](?:[0-9 ().-]{5,29}[0-9])$/;

export function createEmptyPublicProspectForm(language = 'fr') {
  return {
    schemaVersion: PUBLIC_RESPONSE_SCHEMA_VERSION,
    intent: '',
    contact: { fullName: '', email: '', phone: '' },
    consentAccepted: false,
    ownershipAttested: false,
    language,
  };
}

export function validatePublicProspectForm(form) {
  const errors = {};
  const intent = form.intent;
  const fullName = form.contact.fullName.trim();
  const email = form.contact.email.trim();
  const phone = form.contact.phone.trim();

  if (!fullName) errors.fullName = 'required';
  if (!email) errors.email = 'required';
  else if (!emailPattern.test(email)) errors.email = 'emailInvalid';

  if (intent === 'property_sale') {
    if (!phone) errors.phone = 'required';
    else if (!phonePattern.test(phone)) errors.phone = 'phoneInvalid';
    if (form.ownershipAttested !== true) errors.ownership = 'ownershipRequired';
  } else if (phone && !phonePattern.test(phone)) {
    errors.phone = 'phoneInvalid';
  }

  if (!form.consentAccepted) errors.consent = 'consentRequired';
  return errors;
}

export const hasValidationErrors = (errors) => Object.keys(errors).length > 0;

function deepFreeze(value) {
  if (value && typeof value === 'object') {
    Object.values(value).forEach(deepFreeze);
    Object.freeze(value);
  }
  return value;
}

export function freezePublicResponseAttempt(operationId, formResponse) {
  return deepFreeze({ operationId, formResponse });
}

export function invalidatePublicResponseAttempt() {
  return null;
}

/** @deprecated Compatibility alias used by older tests during migration. */
export const EMPTY_PUBLIC_RESPONSE_FORM = EMPTY_PUBLIC_PROSPECT_FORM;
export const validatePublicOwnerResponse = validatePublicProspectForm;
